import { Broker } from '../../../queries/brokerQueries';

/** True when the broker has an address line to show (a street line, or a complete city, state and zip). */
export const hasBrokerAddress = (broker: Broker) =>
    !!(broker.street1 || broker.street2 || (broker.city && broker.state && broker.zipCode));
